import useParticipants from "../../components/useParticipants/useParticipants";
import useSelectedParticipant from "../useSelectedParticipant/useSelectedParticipant";

const useMainParticipant = (room) => {
  const [selectedParticipant] = useSelectedParticipant();
  const participants = useParticipants(room);
  //   const { room } = window;
  const localParticipant = room?.localParticipant;

  return selectedParticipant || participants[0] || localParticipant;
};

export default useMainParticipant;
